export default function composeShortAddress(address) {
  return address.substr(0, 4) + '....' + address.substr(address.length - 4); 
};
